// extracted by mini-css-extract-plugin
export default {"image_logo":"transformationOnline_image_logo__5mrgH","cover":"transformationOnline_cover__4cm-p"};